import ReactDOM from 'react-dom';

import { App } from './components/templates/App';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
